import { Link } from '@/components/atoms/Link';
import { ResponsiveWrapper } from '@/components/atoms/ResponsiveWrapper/ResponsiveWrapper';
import { InternalLinks } from '@/components/molecules/InternalLinks/InternalLinks';
import ZipCodeLink from '@/components/molecules/ZipCodeLink/ZipCodeLink';
import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { useRouter } from 'next/router';
import { FC, PropsWithChildren } from 'react';

export const BuildAndPriceTemplate: FC<
  PropsWithChildren<{
    title: string;
    hideZipCode?: boolean;
    backButtonText?: string;
  }>
> = ({ title, backButtonText, hideZipCode, children }) => {
  const router = useRouter();
  const path = router.pathname.trim().split('/');
  const previousStep = path.slice(0, path.length - 1).join('/');
  const zip = router.query.location as string;
  return (
    <ResponsiveWrapper>
      <div className="w-full">
        <div className="flex min-h-[80vh] w-full justify-center pb-[80px] pt-[20px]">
          <div className="flex w-full flex-col gap-[20px] px-[20px] m:px-[40px] l:w-[1000px]">
            <div className="flex flex-row justify-between">
              {backButtonText && (
                <Link
                  href={{ pathname: previousStep, query: router.query }}
                  className="flex items-center gap-2.5 underline"
                >
                  <ArrowLeftIcon stroke="black" width={16} height={16} />
                  {backButtonText}
                </Link>
              )}
              {!hideZipCode && path.length > 3 && (
                <ZipCodeLink
                  zip={zip}
                  persistZip={true}
                  locationModalTitle="Incentives and Rebates"
                  locationModalDescription="Enter your city or Zip Code to view your state incentives. This change will apply to all vehicles you view on ev.com."
                />
              )}
            </div>
            <h1 className="text-display32px">{title}</h1>
            {children}
          </div>
        </div>

        <InternalLinks />
      </div>
    </ResponsiveWrapper>
  );
};

export default BuildAndPriceTemplate;
